module.exports = __webpack_public_path__ + "img/Bullet_05_guardians.290e3778.png";